// Styles
import { debounce } from 'lodash';
import { atQuery } from '../../scripts/components/mediaQueries';
import './plp-hero-designer.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPlpHeroDesigner = (context) => {
  const plpHeroDesignerSection = context.closest('.shopify-section');
  if (!plpHeroDesignerSection) return;

  const description = plpHeroDesignerSection.querySelector(
    '.plp-hero-designer__description',
  );
  if (!description) return;
  const cnt = description.querySelector('[data-collapse-cnt]');
  const head = description.querySelector('[data-collapse-head]');
  if (!cnt || !head) return;

  const descriptionCheck = debounce(() => {
    if (cnt.scrollHeight <= cnt.clientHeight) {
      head.classList.add('hidden');
    } else {
      head.classList.remove('hidden');
    }
  }, 100);
  descriptionCheck();
  window.addEventListener('resize', () => descriptionCheck());
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.plp-hero-designer__container'),
    (el) => {
      window.dAgency.initPlpHeroDesigner(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.plp-hero-designer__container'),
      (el) => {
        window.dAgency.initPlpHeroDesigner(el);
      },
    );
  });
}
